var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('d-header',{attrs:{"actions":_vm.actions,"fluid":""}},[_c('h1',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$t("users"))+"\n    ")])]),_vm._v(" "),_c('v-user-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }